export function loadScript(src) {
  const script = document.createElement('script');
  script.setAttribute('src', src);
  script.async = true;
  document.body.appendChild(script);
}

export function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

export function getContentLength(body) {
  try {
    if (!body) {
      return 0;
    } else if (isObject(body)) {
      return JSON.stringify(body).length;
    } else if (typeof body === 'string') {
      return body.length;
    }
    return 0;
  } catch (e) {
    return -1;
  }
}

export function encrypt(params, data = '') {
  const { publicKeyRaw } = params;
  try {
    const publicKeyGenerated = forge.pki.publicKeyFromPem(publicKeyRaw);
    const encoded = publicKeyGenerated.encrypt(JSON.stringify(data));
    return forge.util.encode64(encoded);  
  } catch (error) {
    console.error("You didn\'t load enctypt module, try: VGSCollect.load(['encrypt']).create(...)");
    return { error: '001', text: "You didn\'t load enctypt module, try: VGSCollect.load(['encrypt']).create(...)"};

  }
  
}
